import React, { useEffect, useState } from "react";
import Select from 'react-select'
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Handler from "../../../../Helpers/Handler";
import { reloadWindow } from "../../../../Helpers/Utils";

const Register = (props) => {
  const [service, setService] = useState({})
  const [staff, setStaff] = useState([])
  const { id } = useParams()
  const [buttonDisable, setButtonDisable] = useState(false)
  const [value, setValue] = useState()
  const options = [{ label: "PMS", value: "PMS" }, { label: "Bodyshop", value: "Bodyshop" }, { label: "Partchange", value: "Partchange" }]

  const handleChange = (e) => {
    setService((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }
  const handleService = async () => {
    if (!service?.serviceName || service?.serviceName?.trim() === "") {
      toast.error("Service name is required")
    } else if (!service?.serviceType || service?.serviceType?.trim() === "") {
      toast.error("Service Type is required")
    } else if (!service?.staffId) {
      toast.error("Staff Id is required")
    } else {
      setButtonDisable(true)
      const response = await Handler({ method: 'POST', url: `/admin/car/service/add/${id}`, data: { serviceName: service?.serviceName, serviceType: service?.serviceType, staffId: service?.staffId } })
      if (response?.success) {
        toast.success(response?.data?.message)
        setTimeout(() => {
          reloadWindow()
        }, 1500);
      } else {
        setButtonDisable(false)
        toast.error(response?.data?.message)
      }

    }
  }
  const getStaff = async () => {
    const response = await Handler({ method: 'POST', data: { search: value || '' }, url: `/admin/staff/list/0?count=20` })
    if (response?.success) {
      const decryptedData = (response?.data)?.data?.list
      setStaff(decryptedData?.length ? decryptedData?.map((element) => { return { label: element?.staffId + " - " + element?.name?.toUpperCase(), value: element?.staffId } }) : [])
    } else {
      setStaff([])
    }
  }
  useEffect(() => {
    if (value?.length % 3 === 0) getStaff()
  }, [value])

  return (
    <React.Fragment>
      <div className="mb-3">
        <label htmlFor="carId" className="form-label mb-1"> Car ID </label>
        <input className="mb-0 form-control" value={id} disabled />
      </div>
      <div className="mb-3">
        <label htmlFor="serviceName" className="form-label" > Service Name </label>
        <input autoComplete="off" disabled={buttonDisable} id="serviceName" className="form-control" name="serviceName" onChange={handleChange} value={service?.serviceName || ""} placeholder="Service Name" type="text" />
      </div>
      <div className="mb-3">
        <label htmlFor="serviceType" className="form-label" > Service Type </label>

        <Select id="serviceType" name="serviceType" autoComplete='off'
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? "#44084E" : base.borderColor,
              boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
              "&:hover": { borderColor: "#44084E" }
            }),
            option: (style, state) => ({
              ...style,
              backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
              color: state.isSelected ? "white" : "black",
              ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
            })
          }}
          options={options}
          isDisabled={buttonDisable} placeholder="Service Type"
          onChange={(e) => setService((prev) => ({ ...prev, serviceType: e.value }))}
        />

      </div>
      <div className="mb-3">
        <label htmlFor="staffId" className="form-label" > Staff ID </label>

        <Select id="staffId" name="staffId" autoComplete='off' placeholder="Staff ID"
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? "#44084E" : base.borderColor,
              boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
              "&:hover": { borderColor: "#44084E" }
            }),
            option: (style, state) => ({
              ...style,
              backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
              color: state.isSelected ? "white" : "black",
              ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
            })
          }}
          options={staff}
          isDisabled={buttonDisable}
          onInputChange={(e) => setValue(e)}
          onChange={(e) => { setService((prev) => ({ ...prev, staffId: e.value })); }}
        />
      </div>
      <div className="modal-footer align-items-center justify-content-center pb-0"><button disabled={buttonDisable} onClick={handleService} className="btn-primary btn"> Register</button></div>
    </React.Fragment>
  )
}

export default Register